import $ from 'jquery';
import 'owl.carousel';

class Growthpoints {
  constructor() {
    this.nav = $('.js-gp-nav');

    $(window).on('load', () => {
      this.smoothNav();
    });
  }

  smoothNav() {
    if (!this.nav.length) {
      return;
    }

    this.nav.on('click', '.js-gp-nav-link', e => {
      const link = $(e.currentTarget);
      const href = link.attr('href');
      const section = $(`.js-gp-category${href}`);

      if (section.length) {
        e.preventDefault();
        $('body, html')
          .stop()
          .animate(
            {
              scrollTop: section.offset().top - 100,
            },
            500,
          );
      }
    });
  }
}

export default new Growthpoints();



// WEBPACK FOOTER //
// ./src/scripts/modules/growthpoints.js